import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
import genColorBlockStyle from './color-block';
import genInputStyle from './input';
import genPickerStyle from './picker';
import genPresetsStyle from './presets';
export var genActiveStyle = function genActiveStyle(token) {
  return {
    boxShadow: "0 0 0 ".concat(token.controlOutlineWidth, "px ").concat(token.controlOutline),
    borderInlineEndWidth: token.lineWidth,
    outline: 0
  };
};

var genRtlStyle = function genRtlStyle(token) {
  var _rtl;

  var componentCls = token.componentCls;
  return {
    '&-rtl': (_rtl = {}, _defineProperty(_rtl, "".concat(componentCls, "-presets-color"), {
      '&::after': {
        direction: 'ltr'
      }
    }), _defineProperty(_rtl, "".concat(componentCls, "-clear"), {
      '&::after': {
        direction: 'ltr'
      }
    }), _rtl)
  };
};

var genClearStyle = function genClearStyle(token, size, extraStyle) {
  var componentCls = token.componentCls,
      borderRadiusSM = token.borderRadiusSM,
      lineWidth = token.lineWidth,
      colorSplit = token.colorSplit,
      red6 = token.red6;
  return _defineProperty({}, "".concat(componentCls, "-clear"), Object.assign(Object.assign({
    width: size,
    height: size,
    borderRadius: borderRadiusSM,
    border: "".concat(lineWidth, "px solid ").concat(colorSplit),
    position: 'relative',
    cursor: 'pointer',
    overflow: 'hidden'
  }, extraStyle), {
    '&::after': {
      content: '""',
      position: 'absolute',
      insetInlineEnd: lineWidth,
      top: 0,
      display: 'block',
      width: 40,
      height: 2,
      transformOrigin: 'right',
      transform: 'rotate(-45deg)',
      backgroundColor: red6
    }
  }));
};

var genStatusStyle = function genStatusStyle(token) {
  var _ref2;

  var componentCls = token.componentCls,
      colorError = token.colorError,
      colorWarning = token.colorWarning,
      colorErrorBorderHover = token.colorErrorBorderHover,
      colorWarningBorderHover = token.colorWarningBorderHover,
      colorErrorOutline = token.colorErrorOutline,
      colorWarningOutline = token.colorWarningOutline;
  return _ref2 = {}, _defineProperty(_ref2, "&".concat(componentCls, "-status-error"), _defineProperty({
    borderColor: colorError,
    '&:hover': {
      borderColor: colorErrorBorderHover
    }
  }, "&".concat(componentCls, "-trigger-active"), Object.assign({}, genActiveStyle(mergeToken(token, {
    controlOutline: colorErrorOutline
  }))))), _defineProperty(_ref2, "&".concat(componentCls, "-status-warning"), _defineProperty({
    borderColor: colorWarning,
    '&:hover': {
      borderColor: colorWarningBorderHover
    }
  }, "&".concat(componentCls, "-trigger-active"), Object.assign({}, genActiveStyle(mergeToken(token, {
    controlOutline: colorWarningOutline
  }))))), _ref2;
};

var genSizeStyle = function genSizeStyle(token) {
  var _$concat3, _ref3;

  var componentCls = token.componentCls,
      controlHeightLG = token.controlHeightLG,
      controlHeightSM = token.controlHeightSM,
      controlHeight = token.controlHeight,
      controlHeightXS = token.controlHeightXS,
      borderRadius = token.borderRadius,
      borderRadiusSM = token.borderRadiusSM,
      borderRadiusXS = token.borderRadiusXS,
      borderRadiusLG = token.borderRadiusLG,
      fontSizeLG = token.fontSizeLG;
  return _ref3 = {}, _defineProperty(_ref3, "&".concat(componentCls, "-lg"), (_$concat3 = {
    minWidth: controlHeightLG,
    height: controlHeightLG,
    borderRadius: borderRadiusLG
  }, _defineProperty(_$concat3, "".concat(componentCls, "-color-block"), {
    width: controlHeight,
    height: controlHeight,
    borderRadius: borderRadius
  }), _defineProperty(_$concat3, "".concat(componentCls, "-trigger-text"), {
    fontSize: fontSizeLG
  }), _$concat3)), _defineProperty(_ref3, "&".concat(componentCls, "-sm"), _defineProperty({
    minWidth: controlHeightSM,
    height: controlHeightSM,
    borderRadius: borderRadiusSM
  }, "".concat(componentCls, "-color-block"), {
    width: controlHeightXS,
    height: controlHeightXS,
    borderRadius: borderRadiusXS
  })), _ref3;
};

var genColorPickerStyle = function genColorPickerStyle(token) {
  var _Object$assign2, _Object$assign3;

  var componentCls = token.componentCls,
      colorPickerWidth = token.colorPickerWidth,
      colorPrimary = token.colorPrimary,
      motionDurationMid = token.motionDurationMid,
      colorBgElevated = token.colorBgElevated,
      colorTextDisabled = token.colorTextDisabled,
      colorText = token.colorText,
      colorBgContainerDisabled = token.colorBgContainerDisabled,
      borderRadius = token.borderRadius,
      marginXS = token.marginXS,
      marginSM = token.marginSM,
      controlHeight = token.controlHeight,
      controlHeightSM = token.controlHeightSM,
      colorBgTextActive = token.colorBgTextActive,
      colorPickerPresetColorSize = token.colorPickerPresetColorSize,
      colorPickerPreviewSize = token.colorPickerPreviewSize,
      lineWidth = token.lineWidth,
      colorBorder = token.colorBorder,
      paddingXXS = token.paddingXXS,
      fontSize = token.fontSize;
  return [_defineProperty({}, componentCls, Object.assign((_Object$assign3 = {}, _defineProperty(_Object$assign3, "".concat(componentCls, "-inner-content"), Object.assign(Object.assign(Object.assign(Object.assign(_defineProperty({
    display: 'flex',
    flexDirection: 'column',
    width: colorPickerWidth,
    '&-divider': {
      margin: "".concat(marginSM, "px 0 ").concat(marginXS, "px")
    }
  }, "".concat(componentCls, "-panel"), Object.assign({}, genPickerStyle(token))), genColorBlockStyle(token, colorPickerPreviewSize)), genInputStyle(token)), genPresetsStyle(token)), genClearStyle(token, colorPickerPresetColorSize, {
    marginInlineStart: 'auto',
    marginBottom: marginXS
  }))), _defineProperty(_Object$assign3, '&-trigger', Object.assign(Object.assign(Object.assign(Object.assign((_Object$assign2 = {
    minWidth: controlHeight,
    height: controlHeight,
    borderRadius: borderRadius,
    border: "".concat(lineWidth, "px solid ").concat(colorBorder),
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: "all ".concat(motionDurationMid),
    background: colorBgElevated,
    padding: paddingXXS - lineWidth
  }, _defineProperty(_Object$assign2, "".concat(componentCls, "-trigger-text"), {
    marginInlineStart: marginXS,
    marginInlineEnd: marginXS - (paddingXXS - lineWidth),
    fontSize: fontSize,
    color: colorText
  }), _defineProperty(_Object$assign2, '&-active', Object.assign(Object.assign({}, genActiveStyle(token)), {
    borderColor: colorPrimary
  })), _defineProperty(_Object$assign2, '&:hover', {
    borderColor: colorPrimary
  }), _defineProperty(_Object$assign2, '&-disabled', _defineProperty({
    color: colorTextDisabled,
    background: colorBgContainerDisabled,
    cursor: 'not-allowed',
    '&:hover': {
      borderColor: colorBgTextActive
    }
  }, "".concat(componentCls, "-trigger-text"), {
    color: colorTextDisabled
  })), _Object$assign2), genClearStyle(token, controlHeightSM)), genColorBlockStyle(token, controlHeightSM)), genStatusStyle(token)), genSizeStyle(token))), _Object$assign3), genRtlStyle(token)))];
};

export default genComponentStyleHook('ColorPicker', function (token) {
  var colorTextQuaternary = token.colorTextQuaternary,
      marginSM = token.marginSM;
  var colorPickerSliderHeight = 8;
  var colorPickerToken = mergeToken(token, {
    colorPickerWidth: 234,
    colorPickerHandlerSize: 16,
    colorPickerHandlerSizeSM: 12,
    colorPickerAlphaInputWidth: 44,
    colorPickerInputNumberHandleWidth: 16,
    colorPickerPresetColorSize: 18,
    colorPickerInsetShadow: "inset 0 0 1px 0 ".concat(colorTextQuaternary),
    colorPickerSliderHeight: colorPickerSliderHeight,
    colorPickerPreviewSize: colorPickerSliderHeight * 2 + marginSM
  });
  return [genColorPickerStyle(colorPickerToken)];
});